import { GiantNavigation } from "../layout/admin-layout/types";

export const navigation: GiantNavigation[] = [
    {
        id      : 'pages',
        title   : '',
        type    : 'group',
        icon    : 'pages',
        children: [
           
            
        ]
    }
];
